import type { PropsWithChildren, ReactNode } from 'react'

import type { UserPermissionType } from '@fv/models'

import { useHasPermissionFn } from './hooks'

type RootProps = PropsWithChildren<{
  fallback?: ReactNode
}>

type Single = {
  name: UserPermissionType
}

type OneOf = {
  oneOf: UserPermissionType[]
}

type Props = RootProps & (Single | OneOf)

export const HasPermission = (props: Props) => {
  const { fallback, children } = props
  const hasPermission = useHasPermissionFn()

  if ('name' in props) {
    return hasPermission(props.name) ? children : fallback
  }
  if ('oneOf' in props) {
    return props.oneOf.some(name => hasPermission(name)) ? children : fallback
  }

  return null
}

export const HasQuote = ({ children }: PropsWithChildren) => {
  return <HasPermission name="load-creator">{children}</HasPermission>
}
